import React,{useState} from 'react'
import { set } from 'react-hook-form';
import { VehicleList } from './VehicleList';
import ConsignmentList from './ConsignmentList';
import VehicleEntry from './VehicleEntry';
import {Consignment} from './Consignment';
const Index = ({coordinatesSetter}) => {
    const [ showConsignmentRegForm, setConsignmentRegForm ] = useState(false);
    const [showVehicleRegForm, setVehicleRegForm] = useState(false);
    const [showConsignmentList, setShowConsignmentList] = useState(false);
    const [showVehicleList, setShowVehicleList] = useState(false);
  return (
    <div  className='flex flex-col h-full w-full bg-white'>
        <div className='w-full flex justify-center items-center bg-gray-50 rounded-lg'>  
            <h1 className="text-3xl font-semibold tracking-widest text-center bg-gray-50  rounded-lg">
                <div>V<span className="text-lg">EHICLE</span> R<span className="text-lg">EGISTRATION</span></div>
            </h1>
            <button
                className="text-dark bg-yellow-500 ml-6 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center"
                onClick={() => {

                    setVehicleRegForm(false)
                    setShowVehicleList(false)
                    setShowConsignmentList(false)
                    setConsignmentRegForm(!showConsignmentRegForm)
                }}
                >
                { showConsignmentRegForm ? 'Hide Form' : 'New Consignment'}
            </button>
            <button
                className="text-dark bg-yellow-500 ml-6 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center"
                onClick={() => {
                    setConsignmentRegForm(false)
                    setShowVehicleList(false)
                    setShowConsignmentList(false)

                    setVehicleRegForm(!showVehicleRegForm)
                }}
                >
                { showVehicleRegForm ? 'Hide Form' : 'Vehicle Entry'}
            </button>
            <button 
                className="text-dark bg-yellow-500 ml-6 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center"
                onClick={() => {
                    setVehicleRegForm(false)
                    setConsignmentRegForm(false)
                    setShowVehicleList(false)
                    setShowConsignmentList(!showConsignmentList)
                }}>
                Consignment List
            </button>
            <button
                className="text-dark bg-yellow-500 ml-6 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center"
                onClick={() => {
                    setVehicleRegForm(false)
                    setConsignmentRegForm(false)
                    setShowConsignmentList(false)
                    setShowVehicleList(!showVehicleList)
                }}>
                Vehicle List
            </button>
        </div>
        <div className=' w-full'>
            {showVehicleList && <VehicleList />}
            {showConsignmentList && <ConsignmentList coordinatesSetter={coordinatesSetter} />}
            {showVehicleRegForm && <VehicleEntry />}
            {showConsignmentRegForm && <Consignment />}
        </div>
    </div>
  )
}

export default Index